var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27977 2.96783C3.20824 2.96783 3.96091 2.30362 3.96091 1.48428C3.96091 0.66494 3.20824 0.000732422 2.27977 0.000732422C1.3513 0.000732422 0.598633 0.66494 0.598633 1.48428C0.598633 2.30362 1.3513 2.96783 2.27977 2.96783Z",
    fill: "#0A142F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6806 3.95508H0.8787C0.724036 3.95508 0.598511 4.06585 0.598511 4.20234V11.6201C0.598511 11.7566 0.724036 11.8673 0.8787 11.8673H3.6806C3.83526 11.8673 3.96079 11.7566 3.96079 11.6201V4.20234C3.96079 4.06585 3.83526 3.95508 3.6806 3.95508Z",
    fill: "#0A142F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0292 3.54298C10.8317 3.181 9.33376 3.49897 8.43547 4.06915C8.40465 3.96283 8.29481 3.88371 8.16424 3.88371H5.36234C5.20768 3.88371 5.08215 3.99448 5.08215 4.13096V11.5487C5.08215 11.6852 5.20768 11.796 5.36234 11.796H8.16424C8.31891 11.796 8.44443 11.6852 8.44443 11.5487V6.21782C8.89722 5.87364 9.48058 5.76386 9.95802 5.94287C10.4209 6.11546 10.686 6.53679 10.686 7.09806V11.5487C10.686 11.6852 10.8115 11.796 10.9661 11.796H13.768C13.9227 11.796 14.0482 11.6852 14.0482 11.5487V6.60008C14.0163 4.56812 12.9331 3.81596 12.0292 3.54298Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.503cb675e9e67ceabf70e5bc20ca44ab.svg";
export { ForwardRef as ReactComponent };